/* eslint-disable */
import {BhImage} from './BhImage';
import {Ad} from './Ad';
/**
* @description Interface for Avensia.Commerce.Web.Models.Ads.SliderAd
*/
export interface SliderAd extends Ad {
	preTitle: string;
	description: string;
	brandImage: BhImage;
	adImage: BhImage;
	usps: string[];
	isOnTv: boolean;
	splashTextTop: string;
	splashTextMiddle: string;
	splashTextBottom: string;
	splashTextEnd: string;
	isCampaign: boolean;
	isBundleSavings: boolean;
	isPartialCampaign: boolean;
	isLowPrice: boolean;
	isLoweredPrice: boolean;
}
export const isSliderAd = (model: unknown): model is SliderAd => (model as SliderAd).component === 'Bygghemma.Commerce.Web.Models.Ads.SliderAd';

